import { cn } from '../../utils/classNames';
import XSelect from '../common/XSelect';
import { PAGE_SIZE_OPTIONS } from '../../constants/pagination';

const containerClasses = 'flex items-center';
const pageCountClasses = 'text-sm text-content';
// The design draws the page-size control as a pill sitting next to the summary,
// not as a form field, so it overrides the select's default radius and type size.
const pageSizeSelectClasses =
  'inline-block w-auto rounded-full! text-sm! border-border-light! px-4';

const PaginationSummary = ({
  startEntry,
  endEntry,
  totalCount,
  pageSize,
  onPageSizeChange,
  gapClass = 'gap-3',
}) => (
  <div className={cn(containerClasses, gapClass)}>
    <span className={pageCountClasses}>
      Showing {startEntry}-{endEntry} of {totalCount}
    </span>
    <div>
      <XSelect
        value={pageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
        options={PAGE_SIZE_OPTIONS}
        emptyOption={false}
        className={pageSizeSelectClasses}
      />
    </div>
  </div>
);

export default PaginationSummary;
